module.exports = __webpack_public_path__ + "images/emoji/triumph.3a4d49ccef63145ef07a.png";